module.exports = __webpack_public_path__ + "media/images/official/company_mv_sp-0d9ec498515a30a2f7bb331db075cb82.jpg";